export default __webpack_public_path__ + "static/media/sort-arrow-down.63ac7020.svg";